/** Main project script */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.app = {
    init: function () {
        this.megaMenuTrigger();
        this.megaMenuTiering();
        this.closeModalListener();
        this.scrollDown();
        this.swipeboxInit();
    },
    megaMenuTrigger() {
        $(".mega-menu-trigger").click(function(e) {
            e.preventDefault();

            $(".nav-main").toggleClass('mega-menu-open');
            $(".mega-menu").toggleClass('open');
            $(".header-main").toggleClass('menu-open');
            $("body").toggleClass("overflow-hidden");
        });
    },
    closeMegaMenu() {
        $(".nav-main").removeClass('mega-menu-open');
        $(".mega-menu").removeClass('open');
    },
    megaMenuTiering() {
        $(".mega-menu-sub-menu-arrow, .mega-menu-item-link-with-children").click(function(e) {
            var targ = $(this).attr('data-menu-target');

            $(".mega-menu-item-link").removeClass("active in-section");

            $(this).parent().addClass('active in-section');
            $(this).parents(".mega-menu-col").nextAll('.mega-menu-col').find('.mega-menu-sub').removeClass('open');
            $(".mega-menu-sub[data-menu='" + targ + "']").addClass('open');
            $(".mega-menu-sub[data-menu='" + targ + "']").parents(".mega-menu-col").toggleClass('open').siblings().removeClass('open');
        });

        $(".mega-menu-back").click(function(e) {
            e.preventDefault();

            $(this).parents(".mega-menu-col").removeClass('open').prev().addClass('open');
        });
    },
    closeModalListener() {
        $(".modal-close-trigger").click(function(e) {
            let target = $(this).attr('data-refocus');
            $(target)[0].click();
        });
    },
    scrollDown() {
        $(".scroll-down-trigger").click(function() {
            $('html,body').animate({
                scrollTop: $(window).height()
            }, 1500);
            return true;
        });
    },
    swipeboxInit() {
        $('.swipebox').swipebox({
            loopAtEnd: true,
            hideBarsDelay : 0,
            afterOpen: function() {
                var $selectorClose = $("#swipebox-close");
                var clickAction = "touchend click";

                $selectorClose.unbind(clickAction);

                $selectorClose.bind(clickAction, function(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    $.swipebox.close();
                });
            }
        });
    },
};

$(document).ready(function () {
    so.app.init();
});
